import { toast } from "react-toastify";
import { HRMS_FINANCE_API_URL } from "../../../Constants/baseConstant";
import axiosInstance from "../../../../axiosInstance";
import { getDomain } from "../../Base/helper/baseFunctions";


export const GetRegistrationNumberHelper = async (params) => {
    return await axiosInstance(`/finance/ancillary/getCompanyRegistrationNumber`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL, 
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            return { 
                message: "Registration Number retrieved successfully", 
                hasError: false, 
                data: res?.data 
            }
        }).catch(err => {
            return { 
                message: "Unable to retrieve Registration Number", 
                hasError: true, 
                data: err?.response?.data 
            }
        })
}

export const AddRegistrationNumberHelper = async (params) => {
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/ancillary/addCompanyRegistrationNumber`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            pf_no: params?.pf_no,
            esi_no: params?.esi_no,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Registration Number Added Successfully")
            return { 
                message: "Registration Number Added Successfully", 
                hasError: false, 
                data: res?.data 
            }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { 
                message: "Unable to add Registration Number", 
                hasError: true, 
                data: err?.response?.data 
            }
        })
}
